





































import Vue from 'vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

export default Vue.extend({
  name: 'HMDateSelect',
  components: {
    DateRangePicker,
  },
  props: {
    value: {
      type: Object as () => DatePicker,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showClear: {
      type: Boolean,
      default: false,
    },
    hideDefaultDateRanges: {
      type: Boolean,
      default: false,
    },
    showTime: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: null,
    },
    openPicker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateRange: {
        startDate: null,
        endDate: null,
      } as DatePicker,
    };
  },
  mounted() {
    this.dateRange = this.value;
    if (this.openPicker) {
      setTimeout(() => {
        this.$refs.picker.togglePicker(true);
        this.$refs.picker.dateClick(this.value.startDate);
      }, 30);
    }
  },
  watch: {
    dateRange: {
      handler(value: DatePicker) {
        this.$emit('input', value);
      },
    },
  },
  filters: {
    date: function (value: Date): string {
      if (!value) return '';
      return moment(value).format('MMM DD, yyyy');
    },
  },
  methods: {
    clear(): void {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
    },
  },
});
